import type { StoreDirectoryItem } from '@/lib/storeDirectory'
import { storeDisplayName } from '@/lib/storeDirectory'
import { getStorePath, getStoreUrlPreview } from '@/lib/storeSlug'
import { formatRelativeTime } from '@/lib/time'
import { Link } from 'react-router-dom'

interface StorePreviewCardProps {
  item: StoreDirectoryItem
  badge?: string
}

function StorePreviewCard({ item, badge }: StorePreviewCardProps) {
  const { profile, listingCount, lastListedAt } = item
  const name = storeDisplayName(profile)
  const initial = (name[0] || '?').toUpperCase()

  return (
    <Link
      to={getStorePath(profile)}
      className="group flex min-w-[260px] flex-1 items-center gap-3 rounded-[24px] border-2 border-white/10 bg-white/[0.04] p-3 transition-transform hover:-translate-y-0.5 hover:border-[#FFDE00]/50"
    >
      {profile.avatarUrl ? (
        <img src={profile.avatarUrl} alt="" className="h-14 w-14 shrink-0 rounded-full object-cover" />
      ) : (
        <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-[#FF1A1A] font-extrabold text-white">
          {initial}
        </div>
      )}
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <p className="truncate font-display text-lg font-extrabold text-white">{name}</p>
          {badge ? (
            <span className="shrink-0 rounded-full bg-[#FFDE00] px-2 py-0.5 text-[10px] font-extrabold uppercase tracking-wide text-black">
              {badge}
            </span>
          ) : null}
        </div>
        <p className="truncate text-xs font-extrabold text-[#8EA2FF]">
          {getStoreUrlPreview(profile.storeName, profile.storeSlug)}
        </p>
        {profile.bio ? (
          <p className="mt-1 line-clamp-2 text-xs font-semibold text-white/50">{profile.bio}</p>
        ) : null}
        <p className="mt-1 text-[11px] font-extrabold uppercase tracking-wide text-white/40">
          {listingCount} {listingCount === 1 ? 'listing' : 'listings'}
          {lastListedAt ? ` · ${formatRelativeTime(lastListedAt)}` : ''}
        </p>
      </div>
    </Link>
  )
}

export default StorePreviewCard
